"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  width: 216px;\n  height: 40px;\n  border-radius: 4px;\n  padding: 0 8px;\n  box-shadow: 0 2px 6px 0 rgba(66, 74, 97, 0.12);\n  align-items: center;\n  font-family: ", ";\n  white-space: nowrap;\n\n  &.info {\n    color: ", ";\n    background: ", "35;\n  }\n\n  &.success {\n    color: ", ";\n    background: ", "35;\n  }\n\n  &.warning {\n    color: ", ";\n    background: ", "35;\n  }\n\n  &.error {\n    color: ", ";\n    background: ", "35;\n  }\n\n  .icon {\n    font-size: 24px;\n    margin: 0 8px 0 0;\n  }\n\n  .message {\n    font-size: 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  width: 216px;\n  height: 40px;\n  border-radius: 4px;\n  padding: 0 8px;\n  box-shadow: 0 2px 6px 0 rgba(66, 74, 97, 0.12);\n  align-items: center;\n  font-family: ", ";\n  white-space: nowrap;\n\n  &.info {\n    color: ", ";\n    background: ", "35;\n  }\n\n  &.success {\n    color: ", ";\n    background: ", "35;\n  }\n\n  &.warning {\n    color: ", ";\n    background: ", "35;\n  }\n\n  &.error {\n    color: ", ";\n    background: ", "35;\n  }\n\n  .icon {\n    font-size: 24px;\n    margin: 0 8px 0 0;\n  }\n\n  .message {\n    font-size: 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.success;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.success;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.attemptOngoing;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.attemptOngoing;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.system.error;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map